// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cqKQ","title":"styles_title__3EMbe"};